import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import * as serviceWorker from "./serviceWorker";

import "./index.scss";
import DownNotice from "./app/DownNotice";

const down = process.env.REACT_APP_DOWN;
const isDown = down && down === "true";

ReactDOM.render(
  <React.StrictMode>{isDown ? <DownNotice /> : <App />}</React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
